export default __webpack_public_path__ + "static/media/kyc-arrow-left.9453f1ef.svg";